"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryEngine = void 0;
const GeometryEngine_1 = require("./GeometryEngine");
Object.defineProperty(exports, "GeometryEngine", { enumerable: true, get: function () { return GeometryEngine_1.GeometryEngine; } });
//# sourceMappingURL=index.js.map